export default "__VITE_ASSET__BT10xSsN__"